import React from 'react';
import { Stack } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { formatStringToNumber } from 'utils/formatters';
import { InputField, SelectField } from 'components/form';
import { EquipmentFormValue } from '../../../../types';
import { FieldsContainer } from '../../../components/FieldsContainer';
import { equipmentConditions, equipmentYears, makeOptions, inventoryItemStatuses } from '../../../../constants';
import { EQUIPMENT_CLASS } from '@trnsact/business-criteria';

export const CommonInfo = () => {
  const { control } = useFormContext<EquipmentFormValue>();
  const equipmentClassOptions = Object.values(EQUIPMENT_CLASS).map(option => ({
    label: option,
    value: option,
  }));

  return (
    <FieldsContainer columns={5}>
      <Stack direction="row" gap="0.5rem">
        <InputField
          label="Quantity"
          control={control}
          name="commonInfo.quantity"
          formatter={formatStringToNumber}
          inputProps={{ type: 'number', variant: 'outlined' }}
        />

        <SelectField
          label="Year"
          control={control}
          variant="outlined"
          name="commonInfo.year"
          options={equipmentYears}
          required={true}
        />
      </Stack>

      <SelectField
        label="Condition"
        control={control}
        variant="outlined"
        name="commonInfo.condition"
        options={equipmentConditions}
      />

      <SelectField
        label="Make"
        control={control}
        variant="outlined"
        name="commonInfo.make"
        options={makeOptions}
        required={true}
      />

      <InputField
        label="Model"
        name="commonInfo.model"
        control={control}
        inputProps={{ variant: 'outlined', required: true }}
      />

      <InputField label="Serial/VIN#" name="commonInfo.vin" control={control} inputProps={{ variant: 'outlined' }} />

      <InputField label="Stock ID" name="commonInfo.stockId" control={control} inputProps={{ variant: 'outlined' }} />

      <InputField
        label="Mileage"
        control={control}
        name="commonInfo.mileage"
        formatter={formatStringToNumber}
        inputProps={{ type: 'number', variant: 'outlined' }}
      />

      <SelectField
        label="Class"
        control={control}
        variant="outlined"
        name="commonInfo.class"
        options={equipmentClassOptions}
      />

      <InputField
        control={control}
        label="Description"
        name="commonInfo.description"
        inputProps={{ variant: 'outlined', sx: { gridColumn: '4 / 6' } }}
      />

      <SelectField
        label="Status"
        control={control}
        variant="outlined"
        name="commonInfo.inventoryItem.status"
        options={inventoryItemStatuses}
      />
    </FieldsContainer>
  );
};
